import axios from 'axios';
import ForgotPassword from './ForgotPassword.component';
import ForgotUsername from './ForgotUsername.component';
import { HeaderSignIn } from './HeaderSignIn.component';
import ResetPassword from './ResetPassword.component';
import SignIn from './SignIn.component';

export default {
	SignIn,
	HeaderSignIn,
	ResetPassword,
	ForgotPassword,
	ForgotUsername,
};
